import { all } from "redux-saga/effects"
import fetch from "./fetch"
import release from "./release"

export default function* collectionSaga() {
  while (true) {
    yield all({
      fetch: fetch(),
      release: release(),
    })
  }
}
